import { withValidator } from '@ps/web-shared-components';
import type { InjectedValidatorProps } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { AmountInput, FieldValidationMessage } from '@swf/first';

import {
  TXTWCL_Net_loss_limit_XN0X,
  TXTWCL_Net_loss_refers_to_your_total__ELL
} from './NetLossInput.messages.json';
import { errorMessage, input, label } from './NetLossInput.scss';

interface Props {
  validators: InjectedValidatorProps['validators'];
}

const fieldName = 'lossLimit';

const NetLossInput = withValidator<Props>(({ validator, validationErrors }) => {
  const currency = useSelector(select.currency.getRealMoney);

  return (
    <>
      <AmountInput
        fieldName={fieldName}
        currency={currency}
        hasExtension={false}
        label={TXTWCL_Net_loss_limit_XN0X}
        labelClassName={label}
        inputProps={{ inputMode: 'decimal' }}
        classes={{ input }}
        values={{ 0: currency }}
        validator={validator}
        validationErrors={validationErrors}
        tooltip={[TXTWCL_Net_loss_refers_to_your_total__ELL]}
        tooltipHover
        normalize={false}
      />
      <FieldValidationMessage
        fieldName={fieldName}
        errors={validationErrors}
        className={errorMessage}
      />
    </>
  );
});

export default NetLossInput;
